export default __webpack_public_path__ + "static/media/rarible.87ad94a9.svg";